import { useTranslation } from '@gimlite/common';
import { Main, useStoreUIV2 } from '@gimlite/ui-v2';
import GC from '@gimlite/ui-v2/assets/logo/GC_full';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const MainUse = observer(() => {
  const { SSOStore, MenuStore } = useStoreUIV2();
  const navigate = useNavigate();
  const { t, lang } = useTranslation();
  const me = SSOStore.user;

  useEffect(() => {
    MenuStore.setMenu([
      {
        key: '/',
        position: 'top',
        items: [
          {
            key: '/board',
            label: 'Tableau de bord',
            icon: 'arrow_double_vertical',
          },
        ],
      },
    ]);
  }, []);

  return me ? (
    <Main
      onNavigate={(key: string) => {
        navigate(key);
      }}
      logo={GC()}
    />
  ) : null;
});

export default MainUse;
